module.exports = __webpack_public_path__ + "img/login.44921e2c.png";